<template>
  <panel :title="title" noButton="true" v-has-perms="rolePerm">
    <div>
      <b-form>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.code"
            :external-errors="errors['code']"
            :label-form="'Code' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="text"
            :value="form.code"
            :disabled="!formEditable || id"
            @change="$set(form, 'code', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.name"
            :external-errors="errors['name']"
            :label-form="'Name' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="text"
            :value="form.name"
            :disabled="!formEditable"
            @change="changeName($event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.slug"
            :external-errors="errors['slug']"
            :label-form="'Slug' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="text"
            :value="form.slug"
            :disabled="!formEditable"
            @change="$set(form, 'slug', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.description"
            :external-errors="errors['description']"
            :label-form="'Description' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="text"
            :value="form.description"
            :disabled="!formEditable"
            @change="$set(form, 'description', $event)"
          />
        </b-form-row>
        <b-form-row>
          <form-thux-horizontal-input
            :validator="$v.form.aliquot_perc"
            :external-errors="errors['aliquot_perc']"
            :label-form="'Aliquot percentage' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="number"
            :value="form.aliquot_perc"
            :disabled="!formEditable"
            @change="$set(form, 'aliquot_perc', $event)"
          />
          <form-thux-horizontal-input
            :validator="$v.form.deduct_perc"
            :external-errors="errors['deduct_perc']"
            :label-form="'Deduct percentage' | translate"
            class-form="col-lg-6 mb-2"
            labelColsSm="3"
            labelColsLg="3"
            type="number"
            :value="form.deduct_perc"
            :disabled="!formEditable"
            @change="$set(form, 'deduct_perc', $event)"
          />
        </b-form-row>
      </b-form>
      <div class="mt-3 f-w-600 d-flex justify-content-end">
        <b-button
          class="mr-3"
          variant="default"
          @click.prevent="formEditable ? cancel() : closeForm()">
          {{ formEditable ? 'Cancel' : 'Close' | translate }}
        </b-button>
        <b-button
          variant="primary"
          v-has-perms="editRolePerm"
          @click.prevent="formEditable ? onSubmit() : makeFormEditable()"
          :disabled="$v.form.$invalid">
          {{ formEditable ? 'Save' : 'Edit' | translate }}
        </b-button>
      </div>
    </div>
  </panel>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import { TYPES as VAT_TYPES } from './store'

import slugify from 'slugify'

import ThuxDetailPanelMixin from '../../../components/thux-detail-panel/ThuxDetailPanelMixin'

export default {
  name: 'VatEdit',
  mixins: [ThuxDetailPanelMixin],
  data () {
    return {
      pageName: 'Aliquot vat',
      rolePerm: 'vat_vat_retrieve',
      editRolePerm: 'vat_vat_update'
    }
  },
  computed: {
    ...mapGetters({
      ...VAT_TYPES.GENERIC.vat.vat.DETAIL.GETTERS
    })
  },
  components: { },
  methods: {
    ...mapActions({
      ...VAT_TYPES.GENERIC.vat.vat.DETAIL.ACTIONS
    }),
    getFormData () {
      const formData = Object.assign({}, this.form)
      formData.id = formData.code
      return formData
    },
    changeName (evt) {
      this.$set(this.form, 'name', evt)
      if (this.formEditable) {
        this.setSlug()
      }
    },
    setSlug () {
      this.$v.form.name.$touch()
      if (this.form.name) {
        this.$set(this.form, 'slug', slugify(this.form.name, { remove: /[*+~.()'"!:@]/g }))
      } else {
        this.$set(this.form, 'slug', undefined)
      }
    }
  },
  validations: {
    form: {
      code: { required },
      name: { required },
      slug: { required },
      description: {},
      aliquot_perc: {},
      deduct_perc: {}
    }
  }
}
</script>
